import React from 'react';
import { Form, Button, Loader } from 'semantic-ui-react';

class TeamMemberForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event, { name, value }) {
    this.setState({ [name]: value });
  }

  handleSubmit() {
    const { name, email } = this.state;

    this.props.onSubmit({
      name,
      email
    });
  }

  render() {
    const { member } = this.props;

    return (
      <div>
        <Loader active={!member} />
        {member && (
          <div>
            <Form size="large" onSubmit={this.handleSubmit}>
              <Form.Field>
                <Form.Input
                  placeholder="Name"
                  name="name"
                  defaultValue={member.name}
                  onChange={this.handleInputChange}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  placeholder="Email"
                  name="email"
                  defaultValue={member.email}
                  onChange={this.handleInputChange}
                />
              </Form.Field>
              <Button primary type="submit">
                Save
              </Button>
            </Form>
          </div>
        )}
      </div>
    );
  }
}

export default TeamMemberForm;



// WEBPACK FOOTER //
// ./src/components/TeamMemberForm.js